module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.appClasses,
    attrs: {
      "id": "app"
    }
  }, [(_vm.isMobile) ? _c('header', [_c('MobileNav')], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "block-wrapper"
  }, [_c('Intro')], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "block-wrapper timeline-block-wrapper"
  }, [_c('div', {
    staticClass: "content-wrapper timeline-content-wrapper"
  }, [_c('Timeline')], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('DecadeNav') : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "mobile-wrapper"
  }, [(_vm.selectedDecade === 0) ? _c('Intro') : _vm._e(), _vm._v(" "), _c('TimelineMobile')], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('DecadeNavMobile') : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-420c3662", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-420c3662","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./timeline/js/components/App.vue
// module id = 60
// module chunks = 0